import { render } from "./SocialLinks.vue?vue&type=template&id=cfa4ceba&scoped=true"
import script from "../js/social-links.js?vue&type=script&lang=js"
export * from "../js/social-links.js?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=cfa4ceba&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa4ceba"]])

export default __exports__